export const contentData = [
    {
        id: 1,
        title: "Certification Qualiopi",
        info:
            "Notre centre de formation O3 Académie est certifié Qualiopi. Cette certification, délivrée par des organismes indépendants, est un gage de qualité reconnu à l’échelle nationale. Elle atteste de la rigueur et du professionnalisme de nos méthodes pédagogiques, ainsi que de notre capacité à offrir des formations adaptées et accessibles à tous.",
        img: require('../assets/img/banniere-qualiopi.jpg'),
    },
    {
        id: 2,
        title: "Candidater",
        info: (
            <>
                L’une de nos formations vous intéresse et vous vous sentez prêt.e à passer le cap ? <br /> Découvrez comment procéder pour déposer votre candidature.
            </>
        ),
        shortDescription: (
            <>
                O3 Académie est un centre de formation professionnelle et notre mission est de pouvoir proposer à tout le monde la possibilité de se former sans prendre en compte son niveau de qualification. Néanmoins notre mission n’a de sens que si nous pouvons vous permettre de retrouver rapidement un emploi qualifié à l’issue de la formation. Nous devons donc nous assurer que vous avez bien les capacités à suivre notre parcours de formation. <br /> Nous pourrions vous faire passer des tests et vous “noter” mais nous avons préféré faire autrement…
            </>
        ),
        steps: [
            {
                img: "Etape 1",
                icon:
                    <svg role="img" aria-label="Etape Une" className="step-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69">
                        <g id="IbouXo">
                            <g>
                                <path d="M26.6,1.08c21.98-1.37,36.55,22.61,25.1,41.52-10.21,16.87-34.69,17.51-45.88,1.26C-6.2,26.41,5.54,2.39,26.6,1.08ZM26.86,5.29C9.78,6.43-.36,25.26,8.39,40.11c8.99,15.24,31.24,15.12,40.02-.26,9.1-15.94-3.28-35.78-21.55-34.56Z" fill="#C56F39;" />
                                <path d="M27.29,20.76c-1.04.57-2.08,1.55-3.11,2.08-2.39,1.24-4.43-1.79-2.34-3.53,1.89-1.58,4.57-2.81,6.54-4.36,1.3-.65,2.75.05,3.09,1.43l.02,24.92c-.31,1.88-2.8,2.46-3.87.86-.06-.1-.33-.68-.33-.72v-20.69Z" fill="#C56F39;" />
                            </g>
                        </g>
                    </svg>,
                title: "Contactez-nous",
                description: ["Remplissez le formulaire de contact", "Vous recevez un e-mail destiné à convenir ensemble d'une date d'entretien"]
            },
            {
                img: "Etape 2",
                icon:
                    <svg role="img" aria-label="Etape Deux" className="step-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69">
                        <g id="s6pSnl">
                            <g>
                                <path d="M26.7,1.03C48.54-.23,63.09,23.52,51.84,42.42c-10.55,17.72-36.46,17.72-47,0S6.34,2.22,26.7,1.03ZM26.49,5.63C11.63,6.73,1.79,22.07,6.87,36.1c6.17,17.05,28.96,20.46,39.79,5.84,11.68-15.75-.72-37.75-20.17-36.32Z" fill=" #C56F39;" />
                                <path d="M24.38,37.46h11.07s.46.15.56.19c2.19.84,1.78,3.96-.45,4.4h-12.6c-3.63-.6-4.9-4.5-2.47-7.27,2.91-3.31,10.93-5.25,12.19-9.4,1.54-5.07-4.68-8.33-7.92-4.39-.94,1.14-.78,1.94-1.02,3.26-.24,1.36-1.7,2.17-2.99,1.72-1.9-.66-1.65-2.87-1.26-4.47,1.24-4.98,6.62-7.9,11.52-6.44,6.43,1.92,8.51,9.94,4.17,14.97-2.6,3.01-5.97,4.25-9.23,6.27-.53.33-1.16.72-1.57,1.16Z" fill=" #C56F39;" />
                            </g>
                        </g>
                    </svg>,
                title: "Prenez rendez-vous avec un conseiller",
                description: "Répondez à l'e-mail reçu en précisant la date et l'horaire souhaités parmi les créneaux proposés, ainsi que le mode d'entretien envisagé (présentiel, vidéoconférence ou téléphone)"
            },
            {
                img: "Etape 3",
                icon:
                    <svg role="img" aria-label="Etape Trois" className="step-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69">
                        <g id="uWQx7x">
                            <g>
                                <path d="M26.7,1.03C48.54-.23,63.09,23.52,51.84,42.42c-10.55,17.72-36.45,17.72-47,0C-5.66,24.78,6.34,2.22,26.7,1.03ZM26.49,5.63C11.63,6.73,1.8,22.07,6.87,36.1c6.17,17.06,28.96,20.46,39.79,5.84,11.68-15.75-.72-37.75-20.17-36.32Z" fill="#C56F39;" />
                                <path d="M21.04,14.71c2.56.11,5.36-.22,7.89-.03.88.07,1.92.42,2.69.84,3.68,2.01,4.67,6.75,2.18,10.12,1.61,1.26,2.83,2.98,3.36,4.97,1.05,3.98-.75,8.22-4.3,10.25-3.49,1.99-7.79.93-11.64,1.2-2.75-.49-2.64-4.35.21-4.6,2.38-.21,5.11.22,7.49,0,1.61-.15,3.28-1.56,3.74-3.1.65-2.2-.22-4.47-2.3-5.51-1.9-.95-4.79-.25-6.89-.48-2.61-.29-2.71-4.29.21-4.58,1.59-.16,3.44.15,5.02,0,.82-.08,1.76-.95,1.86-1.77.17-1.31-.43-2.31-1.68-2.7-2.41-.2-5.08.2-7.46-.02-2.74-.25-3-3.88-.4-4.58Z" fill="#C56F39;" />
                            </g>
                        </g>
                    </svg>,
                title: "Accompagnement personnalisé",
                description: "À la suite de ce rendez-vous avec un conseiller, vous bénéficierez d’un accompagnement personnalisé jusqu'au début de la formation"
            }
        ],
        img: require('../assets/img/banniere-candidater.jpg'),
    },
    {
        id: 3,
        title: "Nous contacter",
        info: "Pour tout renseignement relatif à O3 Académie ou à nos formations, n'hésitez pas à nous envoyer un message via le formulaire de contact ci-dessous.",
        img: require('../assets/img/banniere-contact.jpg'),
    },
    {
        id: 4,
        title: "Nos Formations",
        info: "Chez O3 Académie, nous proposons des formations adaptées aux enjeux actuels, destinées à accompagner les professionnels, les organisations et les personnes en reconversion dans leur développement. Nos programmes, conçus dans une approche inclusive, sont accessibles à tous, notamment aux personnes neuroatypiques ou en situation de handicap.",
        img: require('../assets/img/banniere-contact.jpg'),
    },
    {
        id: 5,
        title: "Qui sommes-nous ?",
        info: (
            <>
                Le Groupe O3 est un acteur engagé de l’économie sociale et solidaire, fondé sur des valeurs fortes : <strong>l’inclusion, la responsabilité sociale et l’innovation</strong>. À travers ses différentes filiales, O3 développe des activités économiques porteuses de sens, en créant des <strong>emplois durables et adaptés</strong> pour des personnes en situation de handicap ou éloignées de l’emploi.
            </>
        ),
        img: require('../assets/img/qui-sommes-nous.jpg'),

    },
]